import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CoreApiService} from "../../../core/service/core-api.service";
import {ApiResponseDto} from "../../../core/interfaces/core.types";
import {UserNotificationOverviewDto} from "../types/user-notifications.types";


@Injectable({ providedIn: 'root' })
export abstract class NotificationsApiService {

  endPoint: string = "mvseu/eu/endUser"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public closeNotification(id: number): Observable<ApiResponseDto> {
    return this.coreApiService.get(`${this.endPoint}/closeNotification/${id}`);
  }

  public destroyNotification(id: number): Observable<ApiResponseDto> {
    return this.coreApiService.get(`${this.endPoint}/destroyNotification/${id}`);
  }

  public getNotifications(): Observable<UserNotificationOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}/getNotifications`);
  }


}
